"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransportType = exports.AttachmentType = void 0;
var AttachmentType;
(function (AttachmentType) {
    AttachmentType["EWS"] = "ews";
    AttachmentType["EWS_S3"] = "ews-s3";
    AttachmentType["EXCEL"] = "excel";
    AttachmentType["FB_FILE"] = "file";
    AttachmentType["IMAGE"] = "image";
    AttachmentType["LINK"] = "link";
    AttachmentType["OUTLOOK365"] = "o365file";
    AttachmentType["OUTLOOK365_S3"] = "o365file-s3";
    AttachmentType["PDF"] = "pdf";
    AttachmentType["PRODUCT"] = "product";
    AttachmentType["PRODUCT_COLLECTION"] = "productCollection";
    AttachmentType["RICHTEXT"] = "richText";
    AttachmentType["TEXT"] = "text";
    AttachmentType["UNSUPPORTED"] = "unsupported";
    AttachmentType["WORDDOC"] = "wordDoc";
})(AttachmentType = exports.AttachmentType || (exports.AttachmentType = {}));
var TransportType;
(function (TransportType) {
    TransportType["MESSENGER"] = "messenger";
    TransportType["OUTLOOK365"] = "outlook365";
    TransportType["SMS"] = "sms";
})(TransportType = exports.TransportType || (exports.TransportType = {}));
//# sourceMappingURL=conversations.js.map